import {
  USER_LIST_SEARCH, USER_LIST_SEARCH_FAILURE, USER_LIST_SEARCH_SUCCESS, USERRETIREE_LIST_SEARCH, USERRETIREE_LIST_SEARCH_FAILURE, USERRETIREE_LIST_SEARCH_SUCCESS
} from './mutation-types'

export default {
  state: {
    users: [],
    usersNextPage: null,
    usersCurrentPage: null,
    usersListLoading: true
  },
  getters: {
    users: state => {
      return state.users
    },
    usersNextPage: state => {
      return state.usersNextPage
    },
    usersCurrentPage: state => {
      return state.usersCurrentPage
    },
    usersListLoading: state => {
      return state.usersListLoading
    }
  },
  actions: {
    [USER_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/users'
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(USER_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USERRETIREE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/users/retiree'
      var callback = () => {}
      if (params) {
        data = params.data
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USERRETIREE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(USERRETIREE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USER_LIST_SEARCH_FAILURE] (state, params) {
      console.log('USER_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [USER_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('USER_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.users = data.data
        if (data.meta['next-page'] === null) {
          state.usersNextPage = null
        }
      } else {
        state.usersListLoading = false
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.users = state.users.concat(data.data)
          state.usersCurrentPage = data.meta['current-page']
        } else {
          state.users = data.data
          state.usersCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.usersNextPage = data.links['next']
        } else {
          state.usersNextPage = null
        }
      }
      if (params.callback) {
        params.callback(data.meta['total-count'])
      }
    },
    [USERRETIREE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('USERRETIREE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [USERRETIREE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('USERRETIREE_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false
      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }
      if (reSearch) {
        // 再検索
        state.users = data.data
        if (data.meta['next-page'] === null) {
          state.usersNextPage = null
        }
      } else {
        state.usersListLoading = false
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.users = state.users.concat(data.data)
          state.usersCurrentPage = data.meta['current-page']
        } else {
          state.users = data.data
          state.usersCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.usersNextPage = data.links['next']
        } else {
          state.usersNextPage = null
        }
      }
      if (params.callback) {
        params.callback(data.meta['total-count'])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user-list.js